import './home.css';

export const Home = () => {
  return (
    <div className='home-container'>
    </div>
  );
}

